module.exports = __webpack_public_path__ + "static/img/awsLogo_S3_black.1da0174.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/awsLogo_S3_black.png
// module id = XaDi
// module chunks = 0